import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const SUM = () => {
  return (
    <CardSection id="SUM" title="SUM">
      <Paragraph>주어진 숫자 값을 더합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>SUM(VALUE_1, [VALUE_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>VALUE_1</b>은 첫 번째 값입니다.
          </Li>
          <Li>
            <b>VALUE_2, ... [선택 사항]</b>은 추가 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>SUM(`Column_A`, `Column_B`, `Column_C`)</Paragraph>
        <Img src="computeSum" />
      </ListSection>
    </CardSection>
  );
};
